import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { CaseResult } from 'app/area/case-report/case-listing/types-store';
import { HeaderVisibilityConfiguration } from 'app/components';
import { RenderMode } from 'app/types-shared';
import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import { ElementLoader } from 'ui';
import { CaseListingTileContainer } from '../case-listing-tile-container';

import styles from './../case-listing-tile-container.scss';
import { useInstanceOptions } from 'app/area/favourite/favourite-context';

interface CaseListingResultListProps {
  translation: any;
  results?: CaseResult[];
  totalNumberOfResults?: number;
  fetching: boolean;
  windowAsScrollableAncestor?: boolean;
  fetchMoreData: () => void;
  primaryActionComponentFactory: PrimaryActionComponentFactory;
  headerVisibilityConfiguration: HeaderVisibilityConfiguration;
  renderMode: RenderMode;
}

export const CaseListingResultList = ({
  results, 
  totalNumberOfResults, 
  fetching, 
  translation, 
  windowAsScrollableAncestor = true,
  fetchMoreData,
  primaryActionComponentFactory, 
  headerVisibilityConfiguration,
  renderMode
}: CaseListingResultListProps) => {
  
  const totalResults = totalNumberOfResults || 0;

  const hasMoreResults = !!results && results.length > 0 && results.length < totalResults;
  const canFetchMore = !!results && totalResults > 0;
  const noResults = !!results && results.length === 0;

  const {
    height: maxHeight
  } = useInstanceOptions();

  return (
    <div className={`${styles.caseListingWrapper} scrollable`} style={maxHeight ? { maxHeight } : undefined}>
      {!!results && results.map((item, index) => <CaseListingTileContainer
        key={`${item.caseNumber}-${index}`}
        caseNumber={item.caseNumber}
        entityId={item.entityId}
        entityStoreKey={item.entityStoreKey}
        primaryActionComponentFactory={primaryActionComponentFactory}
        headerVisibilityConfiguration={headerVisibilityConfiguration}
        renderMode={renderMode}
      />)}
      {hasMoreResults && !fetching && (
        <>
          <button
            type="button"
            data-testid="load-more-hint-button"
            className={`${styles.loadMoreHint} ${styles.hideInPrint}`}
            onClick={fetchMoreData}
          >
            {translation.text_load_more_cases_text}
          </button>
          <div data-testid="load-more-hint-print" className={`${styles.loadMoreHint} ${styles.showInPrint}`}>
            {translation.text_more_cases_exist_print}
          </div>
        </>
      )}

      {canFetchMore && <Waypoint key={`wp${results.length}`}
        onEnter={fetchMoreData}
        scrollableAncestor={windowAsScrollableAncestor ? window : undefined}
        bottomOffset="-10%" />}
      {fetching
        ? <ElementLoader />
        : noResults && <div className='ui-search-no-results'>{translation.search_no_hits}</div>}
    </div>
  );
};
